import { ModalProps } from './_types';
import classnames from 'tailwindcss-classnames';

const Modal: React.FC<ModalProps> = ({
  title,
  isOpen,
  onRequestClose,
  children,
  classNameOverlay,
  classNameContainer,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={classnames(
        'fixed',
        'inset-0',
        'z-50',
        'flex',
        'items-center',
        'justify-center',
        'bg-black',
        'bg-opacity-50',
        classNameOverlay
      )}
    >
      <div
        className={classnames(
          'w-full',
          'max-w-lg',
          'rounded-lg',
          'bg-white',
          'p-6',
          'shadow-lg',
          classNameContainer
        )}
      >
        <div className={classnames('pb-4')}>
          <button
            type="button"
            onClick={onRequestClose}
            className={classnames(
              'text-gray-500',
              'hover:text-gray-700',
              'float-right',
              'mt-0',
              'pt-0'
            )}
          >
            &times;
          </button>
          {title && <h3 className={classnames('text-xl', 'font-bold', 'text-center')}>{title}</h3>}
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
